<template>
  <div class="brand-card-wrap">
    <div v-if="brandData" class="brand-card" :class="cardClasses" :style="cardCssVars">
      <div class="brand-card__avatar">
        <LogoBrand v-if="brandData.id" :brand-id="brandData.id" tooltip-disabled />
        <img v-else class="avatar" :src="brandData.brand_logo">
      </div>
      <div class="brand-card-brand-details">
          <div class="brand-card-brand-details--name">{{ brandData.name }}</div>
          <span class="brand-card-brand-details--email">{{ brandData.brand_email }}</span>
          <span class="brand-card-brand-details--email">{{ brandData.brand_address }}</span>
          <span class="brand-card-brand-details--email">{{ brandData.brand_postal_code }}</span>
          <span class="brand-card-brand-details--email">{{ brandData.brand_city }} {{ brandData.brand_country }}</span>
      </div>
      <div class="brand-card__brand-extra-details">
        <div class="brand-card__brand-extra-details--title">{{ $gettext('Details') }}</div>
        <ul class="brand-card__brand-extra-details--list">
            <li class="extra-detail"><span>{{ brandData.label_0 }}</span> <span>{{ brandData.field_0 }}</span></li>
            <li class="extra-detail"><span>{{ brandData.label_1 }}</span> <span>{{ brandData.field_1 }}</span></li>
            <li class="extra-detail"><span>{{ brandData.label_2 }}</span> <span>{{ brandData.field_2 }}</span></li>
            <li class="extra-detail"><span>{{ brandData.label_3 }}</span> <span>{{ brandData.field_3 }}</span></li>
            <li class="extra-detail"><span>{{ brandData.label_4 }}</span> <span>{{ brandData.field_4 }}</span></li>
            <li class="extra-detail"><span>{{ brandData.label_5 }}</span> <span>{{ brandData.field_5 }}</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import LogoBrand from "@/components/brands/LogoBrand"

export default {
  name: 'BrandCard',
  components: {
    LogoBrand,
  },
  props: {
    brandData: {
      type: Object,
      default: () => {}
    },
    status: {
      type: String,
      default: 'active'
    },
  },
  computed: {
    ...mapGetters({ 
      currentUser: 'main/getCurrentUser',
      availableCompanies: "team/getMyOwnCompanies"
    }),
    cardClasses () {
      let cssClasses = ''
      if (this.status === 'inactive') {
        cssClasses += 'brand-card--inactive gk-tip gk-tip--team-inactive'
      }
      if (this.status === 'pending') {
        cssClasses += 'brand-card--pending gk-tip gk-tip--team-pending'
      }
      return cssClasses
    },
    cardCssVars () {
      let cssVars = ''
      if (this.status === 'inactive') {
        cssVars += `--inactivetiptext: '${ this.$gettext('inactive') }'`
      }
      if (this.status === 'pending') {
        cssVars += `--pendingtiptext: '${ this.$gettext('invite pending') }'`
      }
      return cssVars
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
  .brand-card {
    $avatarSize: 200px;

    max-height: 250px;
    height: 250px;

    border: 1px solid #d1d1d1;
    border-radius: $radiusLg;
    padding: 0.5rem !important;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    width: 100%;
    position: relative;
    align-items: center;
    overflow: hidden;

    .brand-card-brand-details {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      width: 100%;
      height: 100%;

      &--name, &--email {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
      }
      &--name {
        font-size: 20px;
        font-family: 'DINNextLTPro-Medium';
      }
      &--email {
        font-size: 14px;
        opacity: 0.6;
      }
      &--data {
        padding-top: 0.5rem;
        margin-top: 0.5rem;
        border-top: 1px solid #f2f2f2;
        width: 100%;
      }
      &--actions {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        font-size: 14px;
      }
    }

    &__avatar {
      width: $avatarSize;
      height: $avatarSize;
      flex-shrink: 0;
      background: #ebebeb;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      color: white;
      overflow: hidden;

      .profile-badge {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .profile-badge, .avatar { width: 100%; height: 100%; }
      .avatar {
        border-radius: 100%;
        margin: 0; float: none;
      }

    }
    &__brand-extra-details {
      border-top: 1px solid #f2f2f2;
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding-top: 0.5rem;
      &--title {
        color: $colorBrand;
        font-size: 14px;
        height: 1.5rem;;
      }
      &--list {
        list-style: none;
        margin: 0;
        padding: 0;
        font-size: 14px;
        height: calc(100% - 1.5rem);
        overflow-y: auto;
      }
      .svg-inline--fa {
        font-size: 12px;
        color: $colorBrand;
      }
    }
    .extra-detail {
      display: flex;
      align-items: center;
      .svg-inline--fa {
        font-size: 12px;
        color: $colorBrand;
        margin-right: 0.25rem;
        padding-top: 2px;
      }
    }
  }
</style>